import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

// Project-wide display formats (see CLAUDE.md → Coding Standards).
export const DATE_FORMAT = 'DD/MM/YYYY';
export const DATETIME_FORMAT = 'DD/MM/YYYY HH:mm';

const FALLBACK_TIMEZONE = 'Asia/Jerusalem';

let currentTimezone = FALLBACK_TIMEZONE;

/**
 * Set the timezone all formatting helpers render in. Called with the logged-in
 * user's timezone on login, and reset to the fallback on logout.
 */
export function setDefaultTimezone(tz?: string | null): void {
  currentTimezone = tz || FALLBACK_TIMEZONE;
  dayjs.tz.setDefault(currentTimezone);
}

export function getDefaultTimezone(): string {
  return currentTimezone;
}

export function formatDate(value?: string | Date | null): string {
  if (!value) return '';
  return dayjs.utc(value).tz(currentTimezone).format(DATE_FORMAT);
}

export function formatDateTime(value?: string | Date | null): string {
  if (!value) return '';
  return dayjs.utc(value).tz(currentTimezone).format(DATETIME_FORMAT);
}
